import React from 'react';
import Form from 'components/molecules/Form';
import Field from 'components/molecules/Field';

const VendorNotes = ({ isView }) => {
  return (
    <div className="section-card">
      <h3 className="section-title">Vendor Notes</h3>
      <Form.Item type="textarea" name="notes" placeholder="Notes...">
        <Field disabled={isView} />
      </Form.Item>
    </div>
  );
};

export default VendorNotes;
